import { SearchResult } from '@rygen/rygen-ui/model';

import { OrderSearchData } from './OrderSearchData';

export class OrderSearchResult extends SearchResult<OrderSearchData> {
  content: OrderSearchData[] = [];

  constructor(opts?: Partial<OrderSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new OrderSearchData(val));
    }
  }
}
